// Homepage + Luxury flagship listing config.
// Update MLS_NUMBER tomorrow (Feb 17 2026, 9:00 AM PT) once GVR assigns it.
// Everything else is pre-staged and ready to render.
export const FLAGSHIP = {
  // Feb 2026 · Task 13 — flagship SOLD 2+ weeks ago and DDF hasn't
  // yet withdrawn it from the active feed. `active: false` hides
  // the featured hero card on the homepage + Luxury landing pages.
  // The MLS® number stays server-side on the HIDDEN_MLS_NUMBERS
  // suppression list so it also disappears from search/tile results.
  // Case study page for this listing was retired Feb 2026 at owner request;
  // the Flagship listing card itself remains live on /luxury and the homepage.
  active: false,
  // Current market status — "JUST LISTED" | "ACCEPTED OFFER" | "SALE PENDING" | "SOLD" | null
  // Renders as a coloured pill on both the homepage featured card and the
  // Luxury flagship page. `status_note` shows a short qualifier under the
  // pill (e.g. "Accepted in 1 week"). Empty string hides both.
  status: "SOLD",
  status_note: "in less than 2 weeks",
  address: "3015 141 Street",
  community: "Elgin Chantrell",  // Enclave / neighbourhood — surfaced in address lines beside city
  city: "Surrey",
  province: "BC",
  // Hosted tour URL — Cotala serves an embed-safe iframe purpose-built
  // for real-estate tours. Both the homepage featured card and the
  // /specialties/luxury flagship page read from this single source of
  // truth, so swapping tours is a one-line change. Cotala embeds are
  // NOT subject to YouTube/Vimeo owner-side "disable embedding" toggles.
  tour_embed_url: "https://tours.cotala.com/87725",
  price: 3297000,  // asking price · GVR-listed
  mls_number: "R3156192",  // GVR-assigned MLS® number for 3015 141 Street
  launch_at: "2026-02-17T17:00:00Z",  // Feb 17 2026 · 9:00 AM PT = 17:00 UTC
  ribbon_days: 7,
  hero_image: "https://cdn.realtor.ca/listings/TS639225244901500000/reb6/highres/2/R3156192_1.jpg",
  virtual_tour_iframe: "https://tours.cotala.com/87725",
  matterport: "https://my.matterport.com/show/?m=RsuVitX8BKc&dh=0",
  description: "Quality, location, and lasting value. A distinguished residence in the heart of Surrey — craftsmanship, wrap-around porch, and grounds designed for entertaining. Represented exclusively by Doug LeMaire, REALTOR® (BCFSA #167790).",
  tagline: "Quality, location, and lasting value.",
  // realtor.ca is the canonical CREA DDF® presentation for this listing.
  // The homepage + luxury pointer strip links straight to it. Set to `null`
  // to hide the pointer everywhere without touching component code.
  realtor_ca_url: "https://www.realtor.ca/real-estate/30162312/3015-141-street-surrey",
};

// Hand-picked "signature" listings pinned into the homepage hero rotation.
// Add live GVR/CREA MLS® numbers as strings (e.g. "R1234567"). Up to
// SIGNATURE_PIN_LIMIT currently-active ones are pinned to the FRONT of the
// daily-rotating 12 and tagged "Featured". FLAGSHIP.mls_number is auto-added
// while FLAGSHIP.active is true. Inactive/suppressed MLS® numbers are skipped.
export const SIGNATURE_MLS = [];
export const SIGNATURE_PIN_LIMIT = 2;
export const getSignatureMlsNumbers = () => {
  const list = [...SIGNATURE_MLS];
  if (FLAGSHIP.active && FLAGSHIP.mls_number) list.unshift(FLAGSHIP.mls_number);
  return Array.from(new Set(list.filter(Boolean)));
};


export const isFlagshipRibbonActive = () => {
  if (!FLAGSHIP.active) return false;
  const now = Date.now();
  const launch = new Date(FLAGSHIP.launch_at).getTime();
  const end = launch + FLAGSHIP.ribbon_days * 24 * 60 * 60 * 1000;
  return now >= launch && now <= end;
};
